import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { Switch } from '@mui/material';
import { DeviceConfig } from 'console/shared/contexts/device/config/types';
import { CustomIcon } from 'console/shared/components/icon/custom';
import { VehicleDeviceState } from 'console/shared/contexts/vehicle-device/state/types';
import { UniversalMenu } from 'console/shared/components/menu';
import IndicatorService from './icons/service.svg';
import ShockIcon from './icons/device-settings-shock-strong.svg';
import WeakShockIcon from './icons/device-settings-shock-light.svg';
import TiltIcon from './icons/device-settings-tilt-high.svg';
import { VehicleDeviceConfig } from 'console/shared/contexts/vehicle-device/config/types';
export const ServiceSensorsSettingsMenu = memo(function ServiceSensorsSettingsMenu(props) {
    const { anchor, onClose, silent_mode, onChangeSilentMode, onSetServiceMode } = props;
    const { service_mode } = useContext(VehicleDeviceState);
    const { is_support_service_mode } = useContext(VehicleDeviceConfig);
    const { device_id } = useContext(DeviceConfig);
    const onChangeServiceMode = useCallback(() => {
        onSetServiceMode(device_id, !service_mode);
    }, [onSetServiceMode, device_id, service_mode]);
    const onShockChange = useCallback(() => {
        onChangeSilentMode('sensors', 'shock', !silent_mode?.sensors.shock);
    }, [onChangeSilentMode, service_mode]);
    const onWeakShockChange = useCallback(() => {
        onChangeSilentMode('sensors', 'weak_shock', !silent_mode.sensors.weak_shock);
    }, [onChangeSilentMode, service_mode]);
    const onTiltChange = useCallback(() => {
        onChangeSilentMode('sensors', 'tilt', !silent_mode?.sensors.tilt);
    }, [onChangeSilentMode, service_mode]);
    const sensors_items = useMemo(() => [
        {
            label: 'Сильного удара',
            icon: _jsx(CustomIcon, { Icon: ShockIcon, color: "action" }),
            onClick: onShockChange,
            additional_view: (_jsx(Switch, { size: "small", checked: !silent_mode?.sensors.shock })),
        },
        {
            label: 'Слабого удара',
            icon: _jsx(CustomIcon, { Icon: WeakShockIcon, color: "action" }),
            onClick: onWeakShockChange,
            additional_view: (_jsx(Switch, { size: "small", checked: !silent_mode?.sensors.weak_shock })),
        },
        {
            label: 'Наклона',
            icon: _jsx(CustomIcon, { Icon: TiltIcon, viewBox: "0 0 38 38", color: "action" }),
            onClick: onTiltChange,
            additional_view: (_jsx(Switch, { size: "small", checked: !silent_mode?.sensors.tilt })),
        },
    ], [silent_mode?.sensors]);
    const menu_items = useMemo(() => [
        {
            label: 'Режим «Сервис»',
            icon: (_jsx(CustomIcon, { Icon: IndicatorService, viewBox: "0 0 34 34", color: service_mode ? 'warning' : 'action' })),
            onClick: onChangeServiceMode,
            show: is_support_service_mode,
            additional_view: (_jsx(Switch, { size: "small", checked: service_mode, color: service_mode ? 'warning' : 'primary' })),
        },
        {
            group_label: 'Датчики',
            group_items: sensors_items,
        },
    ], [sensors_items, service_mode, is_support_service_mode]);
    return (_jsx(UniversalMenu, { anchor: anchor, menu_items: menu_items, opened: !!anchor, onClose: onClose }));
});
